import { Component, Input } from '@angular/core';
import { PlayerSessionService } from 'src/app/services/player-session.service';
import { PlayerService } from 'src/app/services/player.service';
import { StatesService } from 'src/app/services/states.service';

@Component({
  selector: 'app-video-component',
  templateUrl: './video-component.component.html',
  styleUrls: ['./video-component.component.scss'],
})
export class VideoComponentComponent {
  @Input() component: any;
  @Input() content: any;
  @Input() disableVideo: any;
  @Input() muted: any;
  timedEvents: any = [];
  pauseEvents: any = [];
  playEvents: any = [];
  endEvents: any = [];
  hideCaptions = false;
  hideCaptionsSub: any;

  constructor(
    private playerSessionService: PlayerSessionService,
    public playerService: PlayerService,
    private statesService: StatesService,
  ) {}

  ngOnInit(): void {
    this.timedEvents = [];
    this.component?.data?.actions.forEach((action: any) => {
      action.events.forEach((_event: any) => {
        if (_event.id == 'onMediaTime') {
          // yes
          let actionToAdd = {
            time: _event.vars[0].value,
            onSeeked: _event.vars[1]?.value ? _event.vars[1]?.value : false,
            action: action,
          };
          this.timedEvents.push(actionToAdd);
        }
        if (_event.id == 'onMediaPaused') {
          this.pauseEvents.push(action);
        }
        if (_event.id == 'onMediaPlays') {
          this.playEvents.push(action);
        }
        if (_event.id == 'onMediaEnds') {
          this.endEvents.push(action);
        }
      });
    });

    this.hideCaptionsSub = this.playerService.hideCaptions.subscribe(
      (hideCaptions) => {
        this.hideCaptions = hideCaptions;
      },
    );
  }

  onMouseDown() {
    this.statesService.onMouseDown(this.component);
  }
  onMouseUp() {
    this.statesService.onMouseUp(this.component);
  }

  onMouseEnter() {
    this.statesService.onMouseEnter(this.component);
  }
  onMouseLeave() {
    this.statesService.onMouseLeave(this.component);
  }

  ngOnDestroy() {
    this.hideCaptionsSub.unsubscribe();
  }
}
